import { render, staticRenderFns } from "./RunPenality.vue?vue&type=template&id=e0dea35e"
import script from "./RunPenality.vue?vue&type=script&lang=js"
export * from "./RunPenality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports